import { useCallback, useEffect, useRef } from "react";
import { getContentAssetUrls } from "../../services/announcement.service";

// Imagem colada no conteudo/corpo do aviso: o valor guardado usa mexx-announcement-asset://{id}
// (a URL real do arquivo expira). Pra exibir no editor, troca marcador -> URL temporaria (POST
// announcements/assets/urls) e, na saida, URL -> marcador. Mesmo padrao do useEmailAssetDisplay,
// so que pra tb_announcement_asset (nao tb_email_template_asset).

const ASSET_MARKER_REGEX = /mexx-announcement-asset:\/\/([1-9][0-9]*)/gi;

const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const extractAssetIds = (html) => {
  const ids = new Set();
  let match;
  ASSET_MARKER_REGEX.lastIndex = 0;
  while ((match = ASSET_MARKER_REGEX.exec(html || "")) !== null) ids.add(Number(match[1]));
  return Array.from(ids);
};

export default function useAnnouncementAssetDisplay(html, onResolved) {
  const urlsRef = useRef({});
  const requestedRef = useRef(new Set());
  const onResolvedRef = useRef(onResolved);
  onResolvedRef.current = onResolved;

  useEffect(() => {
    const missing = extractAssetIds(html).filter((id) => !requestedRef.current.has(id));
    if (!missing.length) return;
    missing.forEach((id) => requestedRef.current.add(id));
    getContentAssetUrls(missing).then((r) => {
      const data = (r && r.data && r.data.data) || [];
      if (!(r && r.data && r.data.success) || !data.length) return;
      data.forEach((asset) => {
        if (asset && asset.url) urlsRef.current[asset.id] = asset.url;
      });
      if (onResolvedRef.current) onResolvedRef.current();
    }).catch(() => {});
  }, [html]);

  const toDisplay = useCallback(
    (value) => (value || "").replace(ASSET_MARKER_REGEX, (marker, id) => urlsRef.current[Number(id)] || marker),
    []
  );

  const fromDisplay = useCallback((value) => {
    let result = value || "";
    Object.keys(urlsRef.current).forEach((id) => {
      const url = urlsRef.current[id];
      if (!url) return;
      const marker = `mexx-announcement-asset://${id}`;
      result = result
        .replace(new RegExp(escapeRegExp(url.replace(/&/g, "&amp;")), "g"), marker)
        .replace(new RegExp(escapeRegExp(url), "g"), marker);
    });
    return result;
  }, []);

  return { toDisplay, fromDisplay };
}
